import { getMicroserviceBaseContext } from '../../constants/api-routing';

const knowledgeCheckContext = getMicroserviceBaseContext('knowledge-check');

export const KNOWLEDGE_CHECK_SERVICE = {
    questionAnswerList: `${knowledgeCheckContext}question_answer_list/`,
    faqHistoryBySessionId: `${knowledgeCheckContext}question_answer_list_by_chat_session_id`,
    faqFeedbackBySessionId: `${knowledgeCheckContext}customer_faq_feedback`,
    generateQuestionAnswerPairs: `${knowledgeCheckContext}generate_question_answer_pairs`,
    evaluateFaqResponse: `${knowledgeCheckContext}evaluate_faq_response`,
}
